import React from 'react';
import * as R from 'ramda';
import styles from './css/HideWhenRoute.scss';
import cn from 'classnames';

const isRoute = (currentRoute, routes) =>
	R.compose(
		index => index !== -1,
		R.findIndex(route => currentRoute === route)
	)(routes);

export const HideWhenRoute = ({ currentRoute, routes, ...props }) => {
	const { children } = props;
	return (
		<div
			className={cn({
				[styles.base]: true,
				[styles.hide]: isRoute(currentRoute, routes)
			})}>
			{children}
		</div>
	);
};

export default HideWhenRoute;
